import { render } from "./SectionFeaturesTab.vue?vue&type=template&id=87db9c46&scoped=true"
import script from "./SectionFeaturesTab.vue?vue&type=script&lang=js"
export * from "./SectionFeaturesTab.vue?vue&type=script&lang=js"

import "./SectionFeaturesTab.vue?vue&type=style&index=0&id=87db9c46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87db9c46"]])

export default __exports__